import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { afterNextRender, Component, inject, Injector, input, output, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ChatEvent, ChatFooter } from '@iot-platform/models/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [MatIcon, FlexLayoutModule, TranslatePipe, FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatButtonModule],
  selector: 'iot-platform-ui-chat-footer',
  templateUrl: './chat-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./chat-footer.component.scss']
})
export class ChatFooterComponent {
  private injector = inject(Injector);

  footer = input.required<ChatFooter>();
  dispatchAction = output<ChatEvent>();

  autosize = viewChild.required<CdkTextareaAutosize>('autosize');

  triggerResize() {
    // Wait for content to render, then trigger textarea resize.
    afterNextRender(() => this.autosize().resizeToFitContent(true), { injector: this.injector });
  }

  form: UntypedFormGroup = new UntypedFormGroup({
    message: new UntypedFormControl(null, [Validators.required, Validators.maxLength(300)])
  });

  get message(): AbstractControl {
    return this.form.get('message') as AbstractControl;
  }

  sendMessage(): void {
    this.dispatchAction.emit({ name: this.footer().action?.()?.name?.(), value: this.message.getRawValue() });
    this.message.reset();
  }

  handleKeydown(event: KeyboardEvent, textarea: HTMLTextAreaElement): void {
    const isMac = navigator.platform.toUpperCase().startsWith('MAC') || navigator.platform.toUpperCase() === 'IPHONE';
    const isCmdEnter = isMac ? event.metaKey && event.key === 'Enter' : event.ctrlKey && event.key === 'Enter';
    if (isCmdEnter) {
      event.preventDefault();
      const cursorPosition = textarea.selectionStart;
      const value = textarea.value;
      textarea.value = value.slice(0, cursorPosition) + '\n' + value.slice(cursorPosition);
      textarea.selectionStart = textarea.selectionEnd = cursorPosition + 1;
    }
  }
}
